/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getPharmacies } from 'app/entities/pharmacy/pharmacy.reducer';
import { getEntities as getImplants } from 'app/entities/implant/implant.reducer';
import { getEntities as getPharmacySuppliers } from 'app/entities/pharmacy-suppliers/pharmacy-suppliers.reducer';
import { getEntities as getPharmacyStockBills } from 'app/entities/pharmacy-stock-bill/pharmacy-stock-bill.reducer';
import { getEntities as getClinicalDictionaries } from 'app/entities/clinical-dictionary/clinical-dictionary.reducer';
import { PharmacyAddedByType } from 'app/shared/model/enumerations/pharmacy-added-by-type.model';
import { createEntity, getEntity, reset, updateEntity } from './pharmacy-implant-stock.reducer';

export const PharmacyImplantStockUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const pharmacies = useAppSelector(state => state.pharmacy.entities);
  const implants = useAppSelector(state => state.implant.entities);
  const pharmacySuppliers = useAppSelector(state => state.pharmacySuppliers.entities);
  const pharmacyStockBills = useAppSelector(state => state.pharmacyStockBill.entities);
  const clinicalDictionaries = useAppSelector(state => state.clinicalDictionary.entities);
  const pharmacyImplantStockEntity = useAppSelector(state => state.pharmacyImplantStock.entity);
  const loading = useAppSelector(state => state.pharmacyImplantStock.loading);
  const updating = useAppSelector(state => state.pharmacyImplantStock.updating);
  const updateSuccess = useAppSelector(state => state.pharmacyImplantStock.updateSuccess);
  const pharmacyAddedByTypeValues = Object.keys(PharmacyAddedByType);

  const handleClose = () => {
    navigate(`/pharmacy-implant-stock${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getPharmacies({}));
    dispatch(getImplants({}));
    dispatch(getPharmacySuppliers({}));
    dispatch(getPharmacyStockBills({}));
    dispatch(getClinicalDictionaries({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.stockQty !== undefined && typeof values.stockQty !== 'number') {
      values.stockQty = Number(values.stockQty);
    }
    if (values.manufacDate !== undefined && typeof values.manufacDate !== 'number') {
      values.manufacDate = Number(values.manufacDate);
    }
    if (values.expDate !== undefined && typeof values.expDate !== 'number') {
      values.expDate = Number(values.expDate);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.mrp !== undefined && typeof values.mrp !== 'number') {
      values.mrp = Number(values.mrp);
    }
    if (values.price !== undefined && typeof values.price !== 'number') {
      values.price = Number(values.price);
    }
    if (values.remainingQuantity !== undefined && typeof values.remainingQuantity !== 'number') {
      values.remainingQuantity = Number(values.remainingQuantity);
    }
    if (values.packs !== undefined && typeof values.packs !== 'number') {
      values.packs = Number(values.packs);
    }
    if (values.discount !== undefined && typeof values.discount !== 'number') {
      values.discount = Number(values.discount);
    }
    if (values.margin !== undefined && typeof values.margin !== 'number') {
      values.margin = Number(values.margin);
    }
    if (values.cessAmount !== undefined && typeof values.cessAmount !== 'number') {
      values.cessAmount = Number(values.cessAmount);
    }
    if (values.importDuty !== undefined && typeof values.importDuty !== 'number') {
      values.importDuty = Number(values.importDuty);
    }
    if (values.freeQty !== undefined && typeof values.freeQty !== 'number') {
      values.freeQty = Number(values.freeQty);
    }

    const entity = {
      ...pharmacyImplantStockEntity,
      ...values,
      pharmacy: pharmacies.find(it => it.id.toString() === values.pharmacy?.toString()),
      implant: implants.find(it => it.id.toString() === values.implant?.toString()),
      supplier: pharmacySuppliers.find(it => it.id.toString() === values.supplier?.toString()),
      bill: pharmacyStockBills.find(it => it.id.toString() === values.bill?.toString()),
      uqcType: clinicalDictionaries.find(it => it.id.toString() === values.uqcType?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          addedByType: 'PHARMACY',
          modifiedByType: 'PHARMACY',
          ...pharmacyImplantStockEntity,
          pharmacy: pharmacyImplantStockEntity?.pharmacy?.id,
          implant: pharmacyImplantStockEntity?.implant?.id,
          supplier: pharmacyImplantStockEntity?.supplier?.id,
          bill: pharmacyImplantStockEntity?.bill?.id,
          uqcType: pharmacyImplantStockEntity?.uqcType?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.pharmacyImplantStock.home.createOrEditLabel" data-cy="PharmacyImplantStockCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.home.createOrEditLabel">
              Create or edit a PharmacyImplantStock
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="pharmacy-implant-stock-id"
                  label={translate('tinyMedicRestApp.pharmacyImplantStock.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantStock.brandId')}
                id="pharmacy-implant-stock-brandId"
                name="brandId"
                data-cy="brandId"
                type="text"
                validate={{
                  maxLength: { value: 150, message: translate('entity.validation.maxlength', { max: 150 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantStock.stockQty')}
                id="pharmacy-implant-stock-stockQty"
                name="stockQty"
                data-cy="stockQty"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantStock.manufacDate')}
                id="pharmacy-implant-stock-manufacDate"
                name="manufacDate"
                data-cy="manufacDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantStock.expDate')}
                id="pharmacy-implant-stock-expDate"
                name="expDate"
                data-cy="expDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantStock.timestampentry')}
                id="pharmacy-implant-stock-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantStock.microSec')}
                id="pharmacy-implant-stock-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantStock.lastupdated')}
                id="pharmacy-implant-stock-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantStock.active')}
                id="pharmacy-implant-stock-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantStock.cursor')}
                id="pharmacy-implant-stock-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantStock.batchNumber')}
                id="pharmacy-implant-stock-batchNumber"
                name="batchNumber"
                data-cy="batchNumber"
                type="text"
                validate={{
                  maxLength: { value: 100, message: translate('entity.validation.maxlength', { max: 100 }) },
                }}
              />
              <UncontrolledTooltip target="batchNumberLabel">
                <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.help.batchNumber" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantStock.taxCode')}
                id="pharmacy-implant-stock-taxCode"
                name="taxCode"
                data-cy="taxCode"
                type="text"
                validate={{
                  maxLength: { value: 100, message: translate('entity.validation.maxlength', { max: 100 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantStock.mrp')}
                id="pharmacy-implant-stock-mrp"
                name="mrp"
                data-cy="mrp"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantStock.price')}
                id="pharmacy-implant-stock-price"
                name="price"
                data-cy="price"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantStock.remainingQuantity')}
                id="pharmacy-implant-stock-remainingQuantity"
                name="remainingQuantity"
                data-cy="remainingQuantity"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantStock.serialNumber')}
                id="pharmacy-implant-stock-serialNumber"
                name="serialNumber"
                data-cy="serialNumber"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantStock.packs')}
                id="pharmacy-implant-stock-packs"
                name="packs"
                data-cy="packs"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantStock.HSNCode')}
                id="pharmacy-implant-stock-HSNCode"
                name="HSNCode"
                data-cy="HSNCode"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantStock.rack')}
                id="pharmacy-implant-stock-rack"
                name="rack"
                data-cy="rack"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantStock.discount')}
                id="pharmacy-implant-stock-discount"
                name="discount"
                data-cy="discount"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantStock.available')}
                id="pharmacy-implant-stock-available"
                name="available"
                data-cy="available"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantStock.internal')}
                id="pharmacy-implant-stock-internal"
                name="internal"
                data-cy="internal"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantStock.shipmentItemId')}
                id="pharmacy-implant-stock-shipmentItemId"
                name="shipmentItemId"
                data-cy="shipmentItemId"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantStock.addedById')}
                id="pharmacy-implant-stock-addedById"
                name="addedById"
                data-cy="addedById"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantStock.modifiedById')}
                id="pharmacy-implant-stock-modifiedById"
                name="modifiedById"
                data-cy="modifiedById"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantStock.addedByType')}
                id="pharmacy-implant-stock-addedByType"
                name="addedByType"
                data-cy="addedByType"
                type="select"
              >
                {pharmacyAddedByTypeValues.map(pharmacyAddedByType => (
                  <option value={pharmacyAddedByType} key={pharmacyAddedByType}>
                    {translate(`tinyMedicRestApp.PharmacyAddedByType.${pharmacyAddedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantStock.modifiedByType')}
                id="pharmacy-implant-stock-modifiedByType"
                name="modifiedByType"
                data-cy="modifiedByType"
                type="select"
              >
                {pharmacyAddedByTypeValues.map(pharmacyAddedByType => (
                  <option value={pharmacyAddedByType} key={pharmacyAddedByType}>
                    {translate(`tinyMedicRestApp.PharmacyAddedByType.${pharmacyAddedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantStock.margin')}
                id="pharmacy-implant-stock-margin"
                name="margin"
                data-cy="margin"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantStock.cessAmount')}
                id="pharmacy-implant-stock-cessAmount"
                name="cessAmount"
                data-cy="cessAmount"
                type="text"
              />
              <UncontrolledTooltip target="cessAmountLabel">
                <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.help.cessAmount" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantStock.exempted')}
                id="pharmacy-implant-stock-exempted"
                name="exempted"
                data-cy="exempted"
                check
                type="checkbox"
              />
              <UncontrolledTooltip target="exemptedLabel">
                <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.help.exempted" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantStock.importDuty')}
                id="pharmacy-implant-stock-importDuty"
                name="importDuty"
                data-cy="importDuty"
                type="text"
              />
              <UncontrolledTooltip target="importDutyLabel">
                <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.help.importDuty" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantStock.freeQty')}
                id="pharmacy-implant-stock-freeQty"
                name="freeQty"
                data-cy="freeQty"
                type="text"
              />
              <UncontrolledTooltip target="freeQtyLabel">
                <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.help.freeQty" />
              </UncontrolledTooltip>
              <ValidatedField
                id="pharmacy-implant-stock-pharmacy"
                name="pharmacy"
                data-cy="pharmacy"
                label={translate('tinyMedicRestApp.pharmacyImplantStock.pharmacy')}
                type="select"
                required
              >
                <option value="" key="0" />
                {pharmacies
                  ? pharmacies.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="pharmacy-implant-stock-implant"
                name="implant"
                data-cy="implant"
                label={translate('tinyMedicRestApp.pharmacyImplantStock.implant')}
                type="select"
                required
              >
                <option value="" key="0" />
                {implants
                  ? implants.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="pharmacy-implant-stock-supplier"
                name="supplier"
                data-cy="supplier"
                label={translate('tinyMedicRestApp.pharmacyImplantStock.supplier')}
                type="select"
                required
              >
                <option value="" key="0" />
                {pharmacySuppliers
                  ? pharmacySuppliers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="pharmacy-implant-stock-bill"
                name="bill"
                data-cy="bill"
                label={translate('tinyMedicRestApp.pharmacyImplantStock.bill')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacyStockBills
                  ? pharmacyStockBills.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-implant-stock-uqcType"
                name="uqcType"
                data-cy="uqcType"
                label={translate('tinyMedicRestApp.pharmacyImplantStock.uqcType')}
                type="select"
              >
                <option value="" key="0" />
                {clinicalDictionaries
                  ? clinicalDictionaries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/pharmacy-implant-stock" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PharmacyImplantStockUpdate;
